module.exports = __webpack_public_path__ + "assets/img/18_1866.ac2bf8c3.jpg";